module.exports = __webpack_public_path__ + "static/media/Is four.4ad5dfcc.png";